import Vue from 'vue';
import { GlobalState } from '../global-state/global-state';
import { isMobile, setGTMcompareProductsEvent } from '../utils/helpers';
import QuickShopClass from './product-quickshop/product-quickshop';
import ProductSamplesClass, { getSampleButtonText, shouldDisabledSampleButton } from '../components/product-samples/product-samples';

export default () => {
  /**
   * Here we want to create two components that communicate with each other.
   * We'll leverage the Global State and use the computed properties
   * to communicate between components
   */

  // Create a Child Component for the Compare Banner
  let CompareBannerComponent,
    collectionGridComponent,
    compareProductsBannerComponent;

  if ($('#compare-banner-template').length) {
    CompareBannerComponent = {
      name: 'compare-banner-component',
      template: '#compare-banner-template',
      props: ['products'],
      methods: {
        removeItem: function (productID) {
          // We have the ability to access the Parent Vue Instance
          // By using $parent. From there we can access the Parent methods.
          this.$parent.removeItemFromCompareList(productID);
        },
      },
    };
  }

  if ($('#bc-sf-filter-products').length) {
    collectionGridComponent = new Vue({
      el: '#bc-sf-filter-products',
      data: {
        sharedState: GlobalState.state,
        isSelectedv1: {},
        productSampleClass: null,
      },
      beforeMount() {
        // Set all products in compare list to true
        if (this.compareList.length) {
          this.compareList.forEach((item) =>
            this.$set(this.isSelected, item.id, true)
          );

          // Update the Compare List Index
          this.compareList.forEach(
            (item, index) => (item.compareListPosition = index)
          );
        }
        this.renderAdditionalMobileUIButtons();

        this.productSampleClass = new ProductSamplesClass(this);
      },
      mounted() {
        // Initialist Mobile Filter Tree
        this.enableMobileFilterTree();

        /*
         * Check if the filters have been selected
         */
        this.checkForActiveMobileFilters();

        /*
         * Check for Any Sample Products within the Collection Product Grid
         */
        this.productSampleClass.checkForSampleLimit();
      },
      methods: {
        toggleMobileFilterTree: function () {
          $('#bc-sf-filter-tree').fadeToggle();
          $(this).toggleClass('.bc-sf-filter-tree-mobile-button-open');
        },
        enableMobileFilterTree: function () {
          // The BC SF Filter buildAdditionalElements()
          // Fires every time a filter is clicked. This means that we need to
          // unbind the click event then bind the client event again.
          // Using the event namespace to specifically target this event
          // otherwise the method would not know which click event to unbind.
          // Resource: https://api.jquery.com/event.namespace/
          $('.collection-listing__sidebar')
            .off('click.mobile_filters')
            .on(
              'click.mobile_filters',
              '#close-mobile-filters, #show-resutls-mobile-filters',
              this.toggleMobileFilterTree
            );
        },
        addToCompareList: function (data) {
          data = JSON.parse(atob(data));
          const card = document.querySelector(`[data-product-id="${data.id}"]`);

          if (this.compareList.length < 3) {
            const checkProductIsInArray = (product) =>
              product === data.productHandle;
            const compareListArray = GlobalState.getCompareList(this);
            let alreadyInArray = compareListArray.some(checkProductIsInArray);

            if (!alreadyInArray) {
              this.compareList.push({
                compareListPosition: this.compareList.length,
                id: data['id'],
                handle: data['handle'],
                title: decodeURIComponent(data['title']),
                imageSource: data['image'],
              });

              // Set Global State
              GlobalState.setCompareList(this, this.compareList);

              // Set Google GTM Data Layer Veriable
              const gtmCompareProducts = GlobalState.getCompareList(this).map(
                (product) => product.title
              );
              setGTMcompareProductsEvent(gtmCompareProducts, 'Collection Page');
              card.classList.add('is-selected');
            }
          }
        },
        removeFromCompareList: function (productID) {
          const deselectedProduct = this.compareList.filter(
            (item) => Number(item.id) === Number(productID)
          )[0];
          const indexInCompareList = deselectedProduct['compareListPosition'];

          // Remove from Array
          this.compareList.splice(indexInCompareList, 1);

          // Update the Compare List Index for Product Removal
          this.compareList.map(
            (item, index) => (item.compareListPosition = index)
          );

          // Update Local Storage
          GlobalState.setCompareList(this, this.compareList);
        },
        renderAdditionalMobileUIButtons: function () {
          if (isMobile()) {
            // Include a Close Button for the Filter Tree
            let closeSVG =
              $(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <g fill="none" fill-rule="evenodd" stroke="#003A81" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                    <path d="M0 7L14 7" transform="rotate(45 3.464 15.536)"/>
                                    <path d="M0 7L14 7" transform="rotate(45 3.464 15.536) rotate(90 7 7)"/>
                                </g>
                            </svg>
                            `);
            let closeButton = $(
              '<button id="close-mobile-filters" class="p-0"></button>'
            );
            let mobileFilterHeading = $(
              '<h3 id="heading-mobile-filters" class="text--brand-navy">Filter</h3>'
            );
            closeButton.appendTo('#bc-sf-filter-tree');
            closeSVG.appendTo('#close-mobile-filters');
            mobileFilterHeading.prependTo('#bc-sf-filter-tree');

            // Create the 'Show Results' CTA for Mobile
            let showResultCTA = $(
              '<button id="show-resutls-mobile-filters" class="button button--primary disabled no-transform" disabled><span class="button__text">Show Results</span></button>'
            );
            showResultCTA.appendTo('#bc-sf-filter-tree');
          }
        },
        checkForActiveMobileFilters() {
          if (isMobile()) {
            let userHasClickedFilter = false;
            let disableShowResults = true;
            let activeFilters = $('.bc-sf-filter-selected-items').length;
            if (disableShowResults && !!activeFilters) {
              $('#show-resutls-mobile-filters').removeAttr('disabled');
              $('#show-resutls-mobile-filters').removeClass('disabled');
            } else {
              if (!userHasClickedFilter) {
                $('.bc-sf-filter-option-item')
                  .off('click.check_filter_click')
                  .on('click.check_filter_click', () => {
                    userHasClickedFilter = true;
                    $('#show-resutls-mobile-filters').removeAttr('disabled');
                    $('#show-resutls-mobile-filters').removeClass('disabled');
                  });
              }
            }
          }
        },
        addToQuickShop: function (handle) {
          QuickShopClass.getInstance().addToQuickshop(handle);
        },
        addCollectionProductToSamples: function (event) {
          // get the button that was clicked in case it is <p/>
          const button = event.target.closest('button');
          const id = button.getAttribute('id');
          if (id) {
            const product = document.querySelector(`[data-product-id="${id}"]`);
            if (product) {
              const variantId = product.dataset.sampleVariantId;
              const handle = product.dataset.sampleHandle;
              const kit = product.dataset.sampleKit === 'true';
              const weight = Number(product.dataset.sampleWeight);
              const variantIds = product.dataset.sampleVariantIds;

              const text = getSampleButtonText(variantId, kit, weight, variantIds, handle);
              const disabled = shouldDisabledSampleButton(text);

              if (!disabled) {
                QuickShopClass.getInstance().addToQuickshop(handle, true, {
                  sampleWeight: weight,
                  sampleKit: kit,
                  sampleVariantId: variantId,
                  sampleHandle: handle,
                  sampleTags: product.dataset.sampleTags,
                  sampleVariantIds: variantIds,
                });
              }

              // this.productSampleClass.addCollectionProductToSamples(event, handle, variantId, kit, weight);
            }
          }
        },
      },
      computed: {
        compareList: function () {
          return this.sharedState.compareProductList;
        },
        isSelected: function () {
          return this.compareList.reduce((acc, item) => ({ ...acc, [`${item.id}`]: true }), {});
        },
      },
    });
  }

  if ($('#compare-banner-component').length) {
    compareProductsBannerComponent = new Vue({
      el: '#compare-banner-component',
      components: {
        'compare-banner': CompareBannerComponent,
      },
      data: function () {
        return {
          sharedState: GlobalState.state,
          activateCompareModule: false,
        };
      },
      updated() {
        // Set Whether the Compare Component is Active
        this.activateCompareModule = this.compareList.length ? true : false;
      },
      mounted() {
        // Set Whether the Compare Component is Active
        this.activateCompareModule = this.compareList.length ? true : false;
      },
      computed: {
        compareList: function () {
          return this.sharedState.compareProductList;
        },
      },
      methods: {
        removeItemFromCompareList: function (productID) {
          let deselectedProduct = this.compareList.filter(
            (item) => Number(item.id) === Number(productID)
          );

          deselectedProduct = deselectedProduct[0];

          let indexInCompareList = deselectedProduct['compareListPosition'];

          // Remove from Array
          this.compareList.splice(indexInCompareList, 1);

          // Update the Compare List Index for Product Removal
          this.compareList.forEach(
            (item, index) => (item.compareListPosition = index)
          );

          // Update Local Storage
          this.sharedState.compareProductList = this.compareList;
          GlobalState.setCompareList(this, this.compareList);
        },
        scrollToCompareModule: function (event) {
          $('html').animate(
            {
              scrollTop:
                $('.collection-listing__compare-results').offset().top - 250,
            },
            800,
            'swing'
          );
        },
      },
    });
  }
};
